<template>
    <div class="binding">
        <!-- <form action="/account/bind" method="get" class="binding layui-form"> -->
        <h1 id="titleTab">
            <a href="javascript:;" @click="titleFun(0)" :class="{ active: titleType == 0 }">手机/邮箱绑定</a>
            <a href="javascript:;" @click="titleFun(1)" :class="{ active: titleType == 1 }">校园/工号绑定</a>
        </h1>
        <div class="instid" v-show="titleType == 1">
            <!-- <van-field readonly clickable name="picker" :value="value" placeholder="点击选择城市" @click="showPicker = true" /> -->
            <!-- <van-popup v-model="showPicker" position="bottom">
                <van-picker show-toolbar :columns="insData" @confirm="onConfirm" @cancel="showPicker = false" />
            </van-popup> -->
            <select name="instid" v-model="ins">
                <option v-for="(item, index) in insData" :key="index" :value="item.id">{{ item.name }}</option>
            </select>
        </div>
        <div class="user">
            <input type="text" name="username" v-model="form.username" :placeholder="placeholder" />
        </div>
        <div class="password">
            <input type="password" name="password" v-model="form.password" placeholder="请输入密码" />
        </div>
        <div class="code">
            <input type="text" name="code" v-model="form.code" placeholder="请输入计算结果" style="width:70%" />
            <img :src="imgSrc" @click="codeFun()" alt="" style="width:20%" />
        </div>
        <button @click="btn">登录</button>
        <!-- <p><a class="left" href="/account/verifyins">注册账号</a> <a class="right" href="/account/passwordreturn">找回密码</a></p> -->
        <!-- </form> -->
    </div>
</template>
<script>
import api from "@/request/api.js";
import { Toast } from "vant";
export default {
    data() {
        return {
            titleType: 0,
            placeholder: "请输入手机号/邮箱号",
            imgSrc: "",
            insData: [],
            ins: 1,
            form: {
                username: "",
                password: "",
                code: "",
                key: ""
            },
            fullPath: "",
            // value:'',
            showPicker: false
        };
    },
    mounted() {
        this.codeFun();
        api.getjobloginins().then((res) => {
            this.insData = res.data;
        });
    },
    methods: {
        titleFun(val) {
            this.titleType = val;
            if (val == 0) {
                this.placeholder = "请输入手机号/邮箱号";
            } else {
                this.placeholder = "请输入校园卡号/职工工号";
            }
        },
        codeFun() {
            api.captcha().then((res) => {
                this.imgSrc = res.data.img;
                this.form.key = res.data.key;
            });
        },
        // onConfirm(value) {
        //     this.value = value;
        //     this.showPicker = false;
        // },
        btn() {
            var data = this.form;
            data.isapp = 1;
            data.remembe = true;
            if (this.titleType != 0) {
                data.logintype = 1;
                data.instid = this.ins;
            }
            api.login(this.$qs.stringify(data)).then((res) => {
                if (res.code == 0) {
                    // localStorage.setItem("token", res.data.token);
                    localStorage.setItem("access-user", res.data.token);
                    Toast("登录成功");
                    // location.href = "./identity.html";
                    this.$router.push(this.fullPath);
                } else {
                    Toast(res.msg);
                    this.codeFun();
                }
            });
        }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.fullPath = from.fullPath;
        });
    }
};
</script>
<style>
.head {
    display: block !important;
}
.binding {
    height: 100%;
    background: url("../assets/loginImg/bj.png") 0 bottom no-repeat;
    padding-top: 3rem;
}
.binding h1 {
    text-align: center;
}

.binding h1 a {
    width: 40%;
    text-align: center;
    font-size: 1rem;
    margin-bottom: 1.5rem;
    display: inline-block;
    color: #333;
    font-weight: 400;
}
.binding h1 a.active {
    font-size: 1.2rem;
}
.binding h1 .active::after {
    content: "";
    width: 2rem;
    height: 7px;
    display: block;
    background: #1283d5;
    border-radius: 10px;
    margin: 10px auto 0;
}

.binding .instid {
    background: url("../assets/loginImg/deptName.png") 0.4rem center no-repeat;
    background-size: 1.2rem;
}

.binding .user {
    background: url("../assets/loginImg/zhanghao.png") 0.4rem center no-repeat;
    background-size: 1.2rem;
}

.binding .password {
    background: url("../assets/loginImg/password.png") 0.5rem center no-repeat;
    background-size: 1rem;
}

.binding .code {
    background: url("../assets/loginImg/code.png") 0.4rem center no-repeat;
    background-size: 1.2rem;
}

.binding > div {
    margin: 0 1rem;
    border-bottom: 1px solid #f1f1f1;
    padding: 1rem 0 1rem 2rem;
}

.binding div input {
    border: 0px;
    vertical-align: middle;
    font-size: 0.8rem;
    width: 100%;
}
.binding select {
    border: 0;
}
/* .binding .layui-form-select dl {
    width: calc(100% + 2rem) !important;
    left: -2rem;
}

.layui-form-select dl dd.layui-this {
    background: #1283d5;
} */

.binding button {
    width: 70%;
    font-size: 1.1rem;
    display: block;
    background: #1283d5;
    border-radius: 1.6rem;
    border: 1px solid #1283d5;
    color: #fff;
    padding: 0.6rem 0;
    margin: 6rem auto 2.13333rem;
}

.binding p > a {
    font-size: 0.8rem;
    color: #1283d5;
    text-align: center;
    margin: 0 auto;
    display: block;
}
.binding p .left {
    float: left;
    margin-left: 4rem;
}
.binding p .right {
    float: right;
    margin-right: 4rem;
}
</style>
